import React from 'react';
import { DAILY_WHEEL_ASSUMTIONS } from '../../utils';
import StreakDaysRow from './StreakDaysRow';
import StreakMilestone from './StreakMilestone';
import {
  StreakColumnContainer,
  StreakColumnContentWrapper,
  StreakColumnHolderSpace,
  StreakColumnBackground,
  StreakColumnHolder,
  DaysStreakContainer,
} from '../styledComponents';
import { useSelector } from 'shared/node_modules/react-redux';

export default function StreakColumn(props) {
  const dailyWheelAssets = useSelector(state => state.assetsPackage.assets.DAILY_WHEEL);
  const { streakAnimDeg, bottomAnimDeg, loginStreakFinal, loginStreakList, bonusInfo } = props;

  const { dailyListWidth, dailyWidthUnit } = DAILY_WHEEL_ASSUMTIONS;
  const wheelHero = bonusInfo?.WHEEL_HERO;

  return (
    <StreakColumnContainer
      hero={wheelHero ? 1 : 0}
      width={dailyListWidth}
      unit={dailyWidthUnit}
      style={{
        transform: [
          {
            translateX: streakAnimDeg,
          },
          {
            translateY: bottomAnimDeg,
          },
        ],
      }}
    >
      <StreakColumnContentWrapper>
        <StreakColumnBackground src={dailyWheelAssets.DAILY_SPIN_COLUMN_BACKGROUND} />
        <StreakColumnHolder>
          <StreakMilestone
            dailyWheelAssets={dailyWheelAssets}
            wheelHero={wheelHero}
            loginStreakFinal={loginStreakFinal}
          />
          <StreakColumnHolderSpace />
          <DaysStreakContainer>
            {loginStreakList?.map((item, index) => {
              return (
                <StreakDaysRow
                  dailyWheelAssets={dailyWheelAssets}
                  key={`login-bonus-item-${index}`}
                  item={item}
                  index={index}
                  day={item?.day}
                  bonusInfo={bonusInfo}
                />
              );
            })}
          </DaysStreakContainer>
        </StreakColumnHolder>
      </StreakColumnContentWrapper>
    </StreakColumnContainer>
  );
}

